import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Action } from "shared/types/Action"
import { RoomPrice } from "shared/types/__generated__/graphql"
import { Readonly } from "shared/ui/readonly/Readonly"

import { ProjectPageSidebarActions } from "pages/project-page/ui/ProjectPageSidebarActions"
import { PriceTag } from "widgets/price-tag/PriceTag"

import "../../../styles/_project-page-sidebar.scss"

export interface RoomMultiSelectSidebarViewModel {
  selectedChildCount: number
  productTotal: number

  price: RoomPrice | null | undefined
  isLoadingPrice?: boolean
  hidePrice?: boolean

  actions: Action[]
  hideControls?: boolean
}

export const RoomMultiSelectSidebarView = React.memo(
  ({
    selectedChildCount,
    productTotal,

    price,
    isLoadingPrice,
    hidePrice,

    actions,
    hideControls
  }: RoomMultiSelectSidebarViewModel) => {
    const { t } = useTranslation()
    return (
      <div
        className="project-page-sidebar project-page-sidebar--room-multi-select"
        data-testid="project-sidebar"
      >
        <div className="project-page-sidebar__content">
          <div className="project-page-sidebar__title" aria-live="polite">
            {selectedChildCount} {t("Project.SelectedGroups")}
          </div>
          <div className={classNames("project-page-sidebar__form")}>
            <div className="flexible-row">
              <Readonly.Root>
                <Readonly.Label>{t("Project.ProductTotal")}</Readonly.Label>
                <Readonly.Value>{productTotal}</Readonly.Value>
              </Readonly.Root>
              {hidePrice ? null : (
                <PriceTag
                  price={price?.priceTotal}
                  currency={price?.currency}
                  isComplete={price?.isComplete}
                  isLoading={isLoadingPrice}
                />
              )}
            </div>
          </div>
        </div>

        {hideControls ? null : <ProjectPageSidebarActions actions={actions} />}
      </div>
    )
  }
)
